module.exports = __webpack_public_path__ + "static/media/cover.0422e176.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cover.jpg
 ** module id = 434
 ** module chunks = 0
 **/